import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import Button from "sweet-web/components/universal/Button";
import TextButton from "sweet-web/components/universal/Button/TextButton";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import { ArchiveChat } from "sweet-web/redux/chat/actions";
import * as selectors from "sweet-web/redux/selectors";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  padding: 20px 20px;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const Controls: React.FC<Props> = props => {
  const { chatId } = props.match.params as { chatId: string };
  const { chat, booking } = props;

  const archiveChat = async () => {
    if (
      booking.status === "CANCELLED" ||
      window.confirm(
        "Are you sure you want to archive this chat? This will cancel all associated bookings"
      )
    ) {
      props.history.push(`/c`);
      await props.ArchiveChat(chat.id);
    }
  };

  const report = async () => {
    // TODO
  };

  return (
    <Wrapper>
      <TextButton
        title={`Archive Chat`}
        small={true}
        onClick={archiveChat}
        style={{ marginRight: 5 }}
      />
      <TextButton
        title={`Report`}
        small={true}
        onClick={report}
        style={{ marginLeft: 5 }}
      />
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { chatId } = ownProps.match.params as { chatId: string };

  return {
    chat: selectors.chat(chatId)(state),
    booking: selectors.getBookingByChat(chatId)(state)
  };
};
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      ArchiveChat
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default withRouter(connector(Controls));
